import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// The Share License dialog's shell (TMS-1681). A License or Manage licenses action is a link into
// the `share_license` frame inside it; the dialog opens once the frame has loaded, and is emptied
// when it closes so the next purchase opened starts fresh — and so reopening the same one loads it
// again rather than showing what was left behind.
export default class extends Controller {
  static targets = ["frame"];

  connect() {
    this.modal = Modal.getOrCreateInstance(this.element);
    this.onLoad = () => this.modal.show();
    this.onHidden = () => {
      this.frameTarget.removeAttribute("src");
      this.frameTarget.innerHTML = "";
    };
    this.frameTarget.addEventListener("turbo:frame-load", this.onLoad);
    this.element.addEventListener("hidden.bs.modal", this.onHidden);
  }

  disconnect() {
    this.frameTarget.removeEventListener("turbo:frame-load", this.onLoad);
    this.element.removeEventListener("hidden.bs.modal", this.onHidden);
    this.modal.dispose();
  }
}
